export default {
    "company_header": "公司詳細資料",
    "header_product_warning": "準備註冊正確的 GrabCAD 產品嗎？請註冊 {0}",
    "label": {
        "first_name": "名",
        "last_name": "姓",
        "name": "名稱",
        "company_name": "公司名稱",
        "university_name": "學校名稱",
        "role": "職位",
        "company_size": "公司規模",
        "phone_number": "電話號碼",
        "printer": "您是否有 3D 印表機？",
        "student_printer": "您的學校是否有 3D 印表機？",
        "uses_printer_for": "您使用 3D 印表機的用途是什麼？",
        "shop_owner": "您會負責管理您的模型商店嗎？",
        "shop_users_expected": "有多人在您的商店提交訂單呢？",
        "email": "電子郵件地址",
        "email_confirm": "確認電子郵件地址",
        "email_again": "重新輸入電子郵件地址",
        "password": "密碼",
        "country": "位置",
				"state": "州/省/區域",
        "password_confirm": "確認密碼",
        "password_again": "重新輸入密碼",
        "password_hint": "最少 6 個字元",
        "interested_in": "我更感興趣...",
        "industry_vertical": "行業類別",
        "industry_level": "職等",
        "business_email": "公司電子郵件地址",
        "business_email_confirm": "確認公司電子郵件地址",
        "recaptcha": "驗證您不是機器人",
        "industry_level_select": "選擇職位等級",
        "company_size_select": "選擇規模",
        "industry_vertical_select": "選擇行業類別"
    },
    "placeholders": {
        "name": "例如 John Smith",
        "first": "第一個",
        "last": "第二個",
        "email": "輸入電子郵件地址",
        "email_confirm": "重新輸入電子郵件地址",
        "password": "輸入密碼",
        "company_name": "輸入公司名稱",
        "university_name": "輸入學校名稱",
        "phone_number": "輸入電話號碼",
        "printer": "選取回復",
        "country": "選取國家/地區",
				"state": "選擇您所在的州/省或區域",
        "business_email": "輸入公司電子郵件地址",
        "business_email_confirm": "確認公司電子郵件地址"
    },
    "terms": {
        "buy_now_text": "按一下「下一步」即表示您確認已經閱讀我們的",
        "workbench_text": "按一下「註冊 Workbench」即表示您確認已經閱讀我們的",
        "print_text": "按一下「註冊」即表示您確認已經閱讀我們的",
        "text": "按一下「註冊 Community」即表示您確認已經閱讀我們的",
        "link": "服務條款"
    },
	"software_terms": {
		"link": "軟體條款"
	},
    "privacy_policy": {
        "and": "和",
        "link": "隱私權原則",
        "text": "並且您接受並同意受其約束。"
    },
    "actions": {
        "next": "下一步",
        "workbench_sign_up": "註冊 Workbench",
        "sign_up_button": "註冊",
        "shop_sign_up": "申請免費試用 GrabCAD Shop",
        "sign_up": "註冊 Community",
        "cancel": "取消"
    },
    "error": {
        "name_empty": "請新增您的姓名",
        "email_taken": "此電子郵件地址已經註冊。請登入或選擇其他電子郵件地址。",
        "email_empty": "請新增您的電子郵件地址",
        "email_nomatch": "電子郵件地址必須匹配",
        "email_look": "請輸入有效的電子郵件地址",
        "password_nomatch": "密碼必須匹配",
        "password_short": "密碼太短。長度至少為 6 個字元。",
        "password_empty": "請輸入密碼",
        "recaptcha": "按一下核取方塊以驗證您不是機器人",
        "country_blocked": "抱歉，您不能註冊 GrabCAD",
        "blank": "不能為空"
    },
    "active": {
        "email": "請輸入您的真實電子郵件地址，我們將傳送帳戶確認連結至該地址。"
    },
    "own_printer": {
        "default": {
            "no_dont_plan": "否，我不打算",
            "no_but_interesed": "否，但是我感興趣",
            "yes_for_work": "是，為了工作",
            "yes_as_hobby": "是，只是作為喜好",
            "yes_for_other": "是，因為其他原因"
        },
        "student": {
            "no_dont_plan": "否，我的學校對 3D 列印不感興趣",
            "no_but_interesed": "否，但我的學校正在選購 3D 印表機",
            "yes_they_do": "是",
            "not_sure": "不確定"
        }
    },
    "uses_printer_for": {
        "professional": "專業用途",
        "education": "教育/研究",
        "hobby": "喜好",
        "dont_use": "我不使用 3D 印表機"
    },
    "level_values": {
        "administrator_principal_superintendent": "行政人員/校長/學區長",
        "biomedical_engineer": "生醫",
        "c_level_executive": "長字輩高層",
        "clinical_preclinical": "臨床/臨床前",
        "dean_department_head": "院長/部門",
        "dentist": "牙醫",
        "designer": "設計師",
        "educator": "教育家",
        "engineer": "工程師",
        "equipment_manufacturer": "設備製造商",
        "lab_owner": "實驗室擁有人",
        "lab_technician": "實驗室技師",
        "marketing": "行銷",
        "medical_education_and_training": "醫療教育與培訓",
        "parent": "父母",
        "practicing_physician": "執業醫師",
        "president_provost": "校長/副校長",
        "prosthetist_orthotist": "義肢師/矯具師",
        "purchasing": "採購",
        "quality": "品質",
        "rd_engineering": "研發/工程師",
        "sales": "業務",
        "senior_management_administration": "高階管理/主管",
        "student": "學生",
        "training": "培訓",
        "other": "其他",
        "not_employed": "待業"
    },
    "industry_values": {
        "aerospace": "航太",
        "architecture": "建築",
        "arts_entertainment": "藝術與環境",
        "automotive": "汽車",
        "commercial_products": "商業產品",
        "consumer_electronics": "消費電子產品",
        "consumer_goods": "消費品",
        "dental": "牙醫",
        "education": "教育",
        "engineering_consulting_service": "工程諮詢服務",
        "government_military": "政府/軍方",
        "industrial_equipment": "工業設備",
        "jewelry": "珠寶",
        "medical_device": "醫療儀器或設備",
        "service_bureau": "服務局",
        "toys": "玩具",
        "reseller": "轉銷商",
        "other": "其他"
    },
    "company_size": {
        "0 - 100": "0 - 100",
        "100 - 500": "100 - 500",
        "500 - 1,000": "500 - 1000",
        "1,000 - 2,500": "1000 - 2500",
        "2,500 - 5,000": "2500 - 5000",
        "5,000 - 10,000": "5000 - 10000",
        "10,000 - 15,000": "10 000 - 15 000",
        "15,000 - 20,000": "15 000 - 20 000",
        "20,000+": "20 000+",
        "not_company": "不是公司"
    },
    "yes_no_values": {
        "yes": "是",
        "no": "否"
    }
}
